import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalConfigurationInstanceList extends BaseModelAPI {

	static entity = 'approvalconfigurationinstancelist'
	static entityName = 'approvalconfigurationinstance';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
